// Formatting for Customer Billing. Money is always to the cent: these are
// customers' bills, and a rounded figure that disagrees with the invoice by a
// dollar reads as an error in the data.

const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function fmtMoney(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return money.format(n).replace(/^-/, '−');
}

// A change: always signed, "—" when it rounds to nothing.
export function fmtChange(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  if (Math.abs(n) < 0.005) return '—';
  return (n > 0 ? '+' : '−') + money.format(Math.abs(n));
}

// Headline figures: $24.23M, $812.4K, $950.
export function fmtCompact(n, { signed = false } = {}) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  const a = Math.abs(n);
  const sign = n < 0 ? '−' : signed && n > 0 ? '+' : '';
  if (a >= 1e6) return `${sign}$${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e4) return `${sign}$${(a / 1e3).toFixed(1)}K`;
  return `${sign}${money.format(a)}`;
}

export function fmtPct(n, { signed = true } = {}) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  if (Math.abs(n) < 0.05) return '0.0%';
  return `${signed && n > 0 ? '+' : n < 0 ? '−' : ''}${Math.abs(n).toFixed(1)}%`;
}

export const fmtNumber = (n) => (n === null || n === undefined ? '—' : Number(n).toLocaleString('en-US'));

// Accounting periods are YYYYMM.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export function periodLabel(p, { short = false } = {}) {
  if (!p) return '—';
  const y = Math.floor(p / 100); const m = p % 100;
  return short ? MONTHS[m - 1] : `${MONTHS[m - 1]} ${y}`;
}

// Soft-Pak writes pickups per week as "# P/U:  2" at the end of a 35-character
// description. Shown as "· 2 pickups/wk", which is what it means.
export function chargeLabel(description) {
  return String(description || '')
    .replace(/\s*#\s*P\/U:\s*(\d+)\s*$/i, (_, n) => ` · ${n} pickup${n === '1' ? '' : 's'}/wk`);
}
